import React from 'react';

const IconSwitzerland = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55.2 38.4" {...props}>
      <g fillRule="evenodd" clipRule="evenodd">
        <path
          fill="#ff0000"
          d="M3.03 0h49.13c1.67 0 3.03 1.36 3.03 3.03v32.33c0 1.66-1.36 3.02-3.02 3.03H3.02C1.36 38.4 0 37.03 0 35.37V3.03C0 1.36 1.36 0 3.03 0z"
        />
        <path fill="#fff" d="M23.2 9.6h8.8v19.2h-8.8z" />
        <path fill="#fff" d="M15.2 14.4h24.8v9.6H15.2z" />
      </g>
    </svg>
  );
};

export default IconSwitzerland;
